import RestApiModel from "@/api/Model/RestApiModel";

class ExternalWebservice extends RestApiModel {
  static getResourceEndpoint() {
    return '/external-webservices';
  }
}

export default ExternalWebservice;
